export const PREDEFINED_MENU_OPTIONS = {
    tierName: 'World',
    menuTitle: 'Select all ',
    menuTitleDeselect: 'Deselect all ',
    worldCode: 'WO',

    worldMenu: {
        nodeCode: 'WO',
        tierId: 0,
        typeId: 1,
        tierName: 'World',
        countryName: 'World',
        isSelected: false,
        title: `Select all World`
    },
    countriesMenu: {
        nodeCode: 'Countries',
        tierId: 0,
        typeId: 0,
        tierName: 'Countries',
        countryName: 'Countries',
        isSelected: false,
        title: `Select all Countries`
    },
    countriesTypeMenu: {
        countryTypeId: 0,
        countryTypeName: 'Countries',
        countryTierId: 0
    }
};

export const COUNTRY_TYPE_DATA = [
    {
        countryTypeId: 1,
        countryTypeName: '',
        countryTierId: 0
    },

    {
        countryTypeId: 2,
        countryTypeName: 'Region',
        countryTierId: 0
    },
    {
        countryTypeId: 3,
        countryTypeName: 'Other region',
        countryTierId: 0
    },
    {
        countryTypeId: 4,
        countryTypeName: 'Tier 1 (Core market country)',
        countryTierId: 1
    },
    {
        countryTypeId: 5,
        countryTypeName: 'Tier 1 (Non-core country)',
        countryTierId: 1
    },
    {
        countryTypeId: 0,
        countryTypeName: 'Countries',
        countryTierId: 0
    },
    {
        countryTypeId: 8,
        countryTypeName: 'Tier 1 (Country with Urban vs Rural)',
        countryTierId: 1
    },
    {
        countryTypeId: 9,
        countryTypeName: 'Tier 1 (Asian core market country)',
        countryTierId: 1
    },
    {
        countryTypeId: 10,
        countryTypeName: 'Tier 1 (Asian Non-core country)',
        countryTierId: 1
    },
    {
        countryTypeId: 31,
        countryTypeName: 'Tier 1 (Nigeria)',
        countryTierId: 1
    },
    {
        countryTypeId: 11,
        countryTypeName: 'Tier 1 (Country with Territories)',
        countryTierId: 1
    },
    {
        countryTypeId: 19,
        countryTypeName: 'Tier 1 (Russia)',
        countryTierId: 1
    },
    {
        countryTypeId: 36,
        countryTypeName: 'Tier 1 (United States)',
        countryTierId: 1
    },
    {
        countryTypeId: 28,
        countryTypeName: 'Tier 2 (Additional)',
        countryTierId: 2
    },
    {
        countryTypeId: 6,
        countryTypeName: 'Modelled country',
        countryTierId: 4
    },
    {
        countryTypeId: 39,
        countryTypeName: 'Non-core Non PKG country',
        countryTierId: 1
    },
    {
        countryTypeId: 7,
        countryTypeName: 'Territory',
        countryTierId: 5
    },

    {
        countryTypeId: 12,
        countryTypeName: 'USDA TB countries',
        countryTierId: 1
    },
    {
        countryTypeId: 13,
        countryTypeName: 'AD2005 Still light grape wine (SE,NO)',
        countryTierId: 1
    },
    {
        countryTypeId: 14,
        countryTypeName: 'AD2005 Other sparkling wine (AT,BE,CH,DK,FI,NL)',
        countryTierId: 1
    },
    {
        countryTypeId: 15,
        countryTypeName: 'Cities',
        countryTierId: 5
    },
    {
        countryTypeId: 16,
        countryTypeName: 'HWF Countries',
        countryTierId: 1
    },
    {
        countryTypeId: 17,
        countryTypeName: 'Asian Non-core HWF country',
        countryTierId: 1
    },
    {
        countryTypeId: 18,
        countryTypeName: 'HW country rankings',
        countryTierId: 1
    },

    {
        countryTypeId: 20,
        countryTypeName: 'Asian HW country rankings',
        countryTierId: 1
    },
    {
        countryTypeId: 21,
        countryTypeName: 'Non-core country RT 2',
        countryTierId: 1
    },
    {
        countryTypeId: 22,
        countryTypeName: 'Non-core country RT 3',
        countryTierId: 1
    },
    {
        countryTypeId: 23,
        countryTypeName: 'Non-core country RT 4',
        countryTierId: 1
    },
    {
        countryTypeId: 24,
        countryTypeName: 'Non-core country RT 5',
        countryTierId: 1
    },
    {
        countryTypeId: 25,
        countryTypeName: 'Non-core country RT 6',
        countryTierId: 1
    },
    {
        countryTypeId: 26,
        countryTypeName: 'Non-core country RT 7',
        countryTierId: 1
    },
    {
        countryTypeId: 27,
        countryTypeName: 'Non-core country RT 1',
        countryTierId: 1
    },

    {
        countryTypeId: 29,
        countryTypeName: 'Tier 3',
        countryTierId: 3
    },
    {
        countryTypeId: 30,
        countryTypeName: 'Non-core country RT 9',
        countryTierId: 1
    },

    {
        countryTypeId: 32,
        countryTypeName: 'States (research)',
        countryTierId: 5
    },
    {
        countryTypeId: 33,
        countryTypeName: 'States (non-research)',
        countryTierId: 5
    },
    {
        countryTypeId: 34,
        countryTypeName: 'US region',
        countryTierId: 5
    },
    {
        countryTypeId: 35,
        countryTypeName: 'US sub-region',
        countryTierId: 5
    },

    {
        countryTypeId: 37,
        countryTypeName: 'Market Insight (Research)',
        countryTierId: 2
    },
    {
        countryTypeId: 38,
        countryTypeName: 'Market Insight (Modelled)',
        countryTierId: 4
    }
];

export const TIER_ZERO = 0;
export const REGION_TYPE_ID = 3;
export const OTHER_REGION_TYPE_ID = 2;
export const WORLD_TYPE_ID = 1;
export const CITIES_TIER_ID = 5;
export const CITIES_TYPE_ID = 15;
